import init from './init';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import pageBannerSection from './sections/page-banner';
import heroSection from './sections/hero';
import articlesSection from './sections/insights';
import logosSection from './sections/logos';
import cardsSection from './sections/cards';
import countdownSection from './sections/countdown';
import videoSection from './sections/video';
import hsForm from './sections/hsForm';
import footerSection from './sections/footer';
import notificationSection from './sections/notification';

/** specific section scripts */
init();
modalSection();
headerSection();
pageBannerSection();
heroSection();
articlesSection();
logosSection();
cardsSection();
countdownSection();
videoSection();
footerSection();
notificationSection();
hsForm();

/** additional scripts */

// Offices toggler
const offices = document.querySelectorAll('.contact_offices ul li');
offices.forEach(office => {
  office.addEventListener('click', event => {
    if (office.classList.contains('-is-open')) {
      office.classList.replace('-is-open', '-is-closed');
      office.parentNode.classList.remove('-is-clicked');
    } else if (office.classList.contains('-is-closed')) {
      office.classList.replace('-is-closed', '-is-open');
      office.parentNode.classList.add('-is-clicked');
    } 
  });
});

// Team bio exanders
const expanders = document.querySelectorAll('.card_content i.expand-bio');
expanders.forEach(expander => {
  expander.addEventListener('click', event => {
    event.stopPropagation();
    let cardWrapper = expander.parentElement.parentElement.parentElement;
    let expandingBio = cardWrapper.querySelector('.card_content_expanded_bio');
    if (expandingBio) {
      expandingBio.classList.replace('-closed', '-open');
    }
  });
});
window.addEventListener('click', event => {
  document.querySelectorAll('.card_content_expanded_bio').forEach(bio => {
    bio.classList.replace('-open', '-closed');
  });
})



// WEBPACK FOOTER //
// ./source/scripts/main.js